export class Constant {
    public static GOOGLE_API_KEY='AIzaSyBTRGoP-2AP5BFsKrylUcgU1byphFT4VKM';
}
